import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './components/pages/login/login.component';
import { BoardsComponent } from './components/pages/boards/boards.component';
import { OpportunitiesComponent } from './components/pages/opportunities/opportunities.component';
import { LeadsComponent } from './components/pages/leads/leads.component';
import { SettingsComponent } from './components/pages/settings/settings.component';
import { UserProfileComponent } from './components/pages/user-profile/user-profile.component';
import { LogoutComponent } from './components/pages/logout/logout.component';
import { AuthGuard } from './auth.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HistoryComponent } from './components/pages/history/history.component';
import { UsermanagementComponent } from './components/pages/settings/usermanagement/usermanagement.component';
import { LookupmanagementComponent } from './components/pages/settings/lookupmanagement/lookupmanagement.component';
import { CustomermanagementComponent } from './components/pages/settings/customermanagement/customermanagement.component';
import { ProductInventoryComponent } from './components/pages/product-inventory/product-inventory.component';
import { StocksComponent } from './components/pages/stocks/stocks.component';
import { OrderComponent } from './components/pages/order/order.component';
import { InfoComponent } from './components/pages/info/info.component';
import { ProductModuleComponent } from './components/pages/Product-Module/productModule.component';
import { CustomerOrdersComponent } from './components/pages/customer-orders/customer-orders.component';
import { OrderItemDetailsComponent } from './components/pages/order-item-details/order-item-details.component';
import { PdfConverterComponent } from './components/pages/pdf-converter/pdf-converter.component';
import { RfpComponent } from './components/pages/rfp/rfp.component';
import { ProspectsComponent } from './components/pages/prospects/prospects.component';
import { RfpFormComponent } from './components/pages/rfp-form/rfp-form.component';
import { ProspectFormComponent } from './components/pages/prospect-form/prospect-form.component';
import { RfpDashboardComponent } from './rfp-dashboard/rfp-dashboard.component';
import { ProspectDashboardComponent } from './prospect-dashboard/prospect-dashboard.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';


const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  { path: 'boards', component: BoardsComponent, canActivate: [AuthGuard] },
  { path: 'opportunities', component: OpportunitiesComponent, canActivate: [AuthGuard] },
  { path: 'opportunities/:filter', component: OpportunitiesComponent, canActivate: [AuthGuard] },
  { path: 'history', component: HistoryComponent, canActivate: [AuthGuard] },
  { path: 'history/:id', component: HistoryComponent, canActivate: [AuthGuard] },
  { path: 'leads', component: LeadsComponent, canActivate: [AuthGuard] },
  { path: 'leads/:id', component: LeadsComponent, canActivate: [AuthGuard] },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
  { path: 'usermgmt', component: UsermanagementComponent, canActivate: [AuthGuard] },
  { path: 'customermgmt', component: CustomermanagementComponent, canActivate: [AuthGuard] },
  { path: 'lookupmgmt', component: LookupmanagementComponent, canActivate: [AuthGuard] },
  { path: 'user_profile', component: UserProfileComponent, canActivate: [AuthGuard] },
  { path: 'logout', component: LogoutComponent, canActivate: [AuthGuard] },
  { path: 'info', component: InfoComponent, canActivate: [AuthGuard] },
  { path: 'Order', component: OrderComponent, canActivate: [AuthGuard] },
  { path: 'inventory', component: ProductInventoryComponent, canActivate: [AuthGuard] },
  { path: 'stocks', component: StocksComponent, canActivate: [AuthGuard] },
  { path: 'product-module', component: ProductModuleComponent, canActivate: [AuthGuard] },
  { path: 'customer-orders', component: CustomerOrdersComponent, canActivate: [AuthGuard] },
  { path: 'orders-items', component: OrderItemDetailsComponent, canActivate: [AuthGuard] },
  { path: 'file-processing', component: PdfConverterComponent, canActivate: [AuthGuard] },
  { path: 'rfp', component: RfpComponent, canActivate: [AuthGuard] },
  { path: 'rfp/new', component: RfpFormComponent, canActivate: [AuthGuard] }, // Add RFP
  { path: 'rfp/edit/:id', component: RfpFormComponent, canActivate: [AuthGuard] }, // Edit RFP
  { path: 'rfp/view/:id', component: RfpFormComponent, canActivate: [AuthGuard] }, // View RFP
  { path: 'prospects', component: ProspectsComponent, canActivate: [AuthGuard] },
  { path: 'prospect/add', component: ProspectFormComponent, canActivate: [AuthGuard] }, // Add prospects
  { path: 'prospect/edit/:id', component: ProspectFormComponent, canActivate: [AuthGuard] }, // Edit prospects
  { path: 'prospect/view/:id', component: ProspectFormComponent, canActivate: [AuthGuard] }, // View prospects
  { path: "rfp-dashboard", component: RfpDashboardComponent, canActivate: [AuthGuard] },
  { path: "prospect-dashboard", component: ProspectDashboardComponent, canActivate: [AuthGuard]},
  { path:"reset-password", component: ResetPasswordComponent , canActivate: [AuthGuard]},
  { path: "**", component: PageNotFoundComponent }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
export const routingComponents = [LoginComponent, UsermanagementComponent, LookupmanagementComponent, CustomermanagementComponent, BoardsComponent, HistoryComponent, OpportunitiesComponent, LeadsComponent, SettingsComponent, UserProfileComponent, LogoutComponent, InfoComponent, StocksComponent, RfpComponent, RfpFormComponent, ProspectsComponent, ProspectFormComponent];
